module.exports = __webpack_public_path__ + "img/cxample_02.5b1f7c24.png";